import { AxiosResponse } from 'axios'
import { format } from 'date-fns'
import axios from 'src/lib/axios'
import { ActionLog } from 'src/types/actionLog'

export const downloadActionLogs = async (
  agencyCode: string,
  startDate: Date,
  endDate: Date,
  userId?: number,
  route?: string
): Promise<AxiosResponse> => {
  const response = await axios
    .post<{ data: ActionLog }>('/api/action-logs/download', {
      id: userId,
      startDate: format(startDate, 'yyyy/MM/dd HH:mm:ss'),
      endDate: format(endDate, 'yyyy/MM/dd HH:mm:ss'),
      agencyCode,
      route,
    })
    .catch((error) => {
      return error.response
    })

  return response
}
